import type { FaireProductEntity } from "../../entity_types/product";

export const p_j6k2pqmr2e: FaireProductEntity = {
  token: "p_j6k2pqmr2e",
  type: "product",
  name: "Trick or Treat Mini KidDough Play Pack",
  brandToken: "b_ehvufz5nw9",
  brandName: "Earth Grown KidDoughs (KidDoughs by EGKD)",
  imageUrl:
    "https://cdn.faire.com/fastly/3334ff274f9cb2cdcc0d8568adce7a1bbb4723619a21b832b1426b71d73c34a8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7eee37c223b11f6ffb370a8bf572f7e4d242f8c6293415a03e260422bc27a468.jpeg",
  ],
  priceDollars: 6,
  description:
    "Spooktacularly sweet adventures. No tricks—just a-dough-rable treats! Collect your own candy stash with candy corn KidDough.\n\nIncludes: 2oz Orange Dough with candy fimo, orange candy bucket, assorted candy charms, vampire teeth charm\n\nAbout our products:\nOur super silky sensory doughs are buildable like a modeling compound but are softer, more pliable, and far longer lasting than any compound you have tried before! Every all-natural KidDough is made with non-toxic food-grade ingredients and is totally taste-safe. These super durable doughs last for at least 120 hours of active airtime and easily wash out of carpets and fabric with just warm water. If ever you experience drying, just knead to rehydrate. KidDough is the best way to play dough!\n\nHandmade in the USA\n\nThis Play Kit is recommended for Ages 3+\n\nScent: Candy Corn\n\nIngredients: Wheat Flour, Salt, Canola Oil, Cream of Tartar, Water, Food Coloring, Organic Potassium Sorbate, and Fragrance\n",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:44.014Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
